import { and, eq } from 'drizzle-orm'
import { IndexedDBAdapter } from '@/adapters/IndexedDBFileStorageAdapter.ts'
import { eventFilesTable, eventsTable } from '../../client-db/src/db/schema'

type DrizzleDb = any

type DemoMediaSeed = {
  eventKey: string
  eventTitle: string
  imageUrl: string
  thumbnailUrl: string
  filename: string
}

const demoMediaSeeds: DemoMediaSeed[] = [
  {
    eventKey: 'wedding-2008',
    eventTitle: 'Daniel and Emily Get Married',
    imageUrl:
      'https://images.unsplash.com/photo-1529636798458-92182e662485?auto=format&fit=crop&w=1600&q=80',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1529636798458-92182e662485?auto=format&fit=crop&w=420&q=75',
    filename: 'demo-seed-wedding.jpg',
  },
  {
    eventKey: 'move-denver-2018',
    eventTitle: 'Move to Denver',
    imageUrl:
      'https://images.unsplash.com/photo-1758523671413-cd178a883d6a?auto=format&fit=crop&w=1600&q=80',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1758523671413-cd178a883d6a?auto=format&fit=crop&w=420&q=75',
    filename: 'demo-seed-moving-day.jpg',
  },
  {
    eventKey: 'yellowstone-trip-2019',
    eventTitle: 'Yellowstone Summer Road Trip',
    imageUrl:
      'https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=1600&q=80',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=420&q=75',
    filename: 'demo-seed-yellowstone-main.jpg',
  },
  {
    eventKey: 'yellowstone-grand-prismatic-2019',
    eventTitle: 'Day 2: Grand Prismatic Overlook Hike',
    imageUrl:
      'https://images.unsplash.com/photo-1520681279154-51b3fb7f5d3f?auto=format&fit=crop&w=1600&q=80',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1520681279154-51b3fb7f5d3f?auto=format&fit=crop&w=420&q=75',
    filename: 'demo-seed-yellowstone-overlook.jpg',
  },
  {
    eventKey: 'olivia-birthday-2020',
    eventTitle: 'Olivia Turns 11',
    imageUrl:
      'https://images.unsplash.com/photo-1608790672275-309c02d888ff?auto=format&fit=crop&w=1600&q=80',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1608790672275-309c02d888ff?auto=format&fit=crop&w=420&q=75',
    filename: 'demo-seed-birthday.jpg',
  },
  {
    eventKey: 'noah-championship-2021',
    eventTitle: 'Noah Wins Little League Championship',
    imageUrl:
      'https://images.unsplash.com/photo-1488426314888-94c9164df81d?auto=format&fit=crop&w=1600&q=80',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1488426314888-94c9164df81d?auto=format&fit=crop&w=420&q=75',
    filename: 'demo-seed-baseball.jpg',
  },
  {
    eventKey: 'daniel-marathon-2023',
    eventTitle: 'Daniel Finishes His First Marathon',
    imageUrl:
      'https://images.unsplash.com/photo-1460353581641-37baddab0fa2?auto=format&fit=crop&w=1600&q=80',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1460353581641-37baddab0fa2?auto=format&fit=crop&w=420&q=75',
    filename: 'demo-seed-baseball.jpg',
  },
  {
    eventKey: 'olivia-middle-school-grad-2023',
    eventTitle: 'Olivia Graduates Middle School',
    imageUrl:
      'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?auto=format&fit=crop&w=1600&q=80',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?auto=format&fit=crop&w=420&q=75',
    filename: 'demo-seed-graduation-middle.jpg',
  },
  {
    eventKey: 'thanksgiving-2024',
    eventTitle: 'Thanksgiving at Home',
    imageUrl:
      'https://images.unsplash.com/photo-1510195429239-8a5c0222144a?auto=format&fit=crop&w=1600&q=80',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1510195429239-8a5c0222144a?auto=format&fit=crop&w=420&q=75',
    filename: 'demo-seed-thanksgiving.jpg',
  },
  {
    eventKey: 'ski-weekend-2025',
    eventTitle: 'Breckenridge Ski Weekend',
    imageUrl:
      'https://images.unsplash.com/photo-1483664852095-d6cc6870702d?auto=format&fit=crop&w=1600&q=80',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1483664852095-d6cc6870702d?auto=format&fit=crop&w=420&q=75',
    filename: 'demo-seed-ski-weekend.jpg',
  },
  {
    eventKey: 'olivia-high-school-grad-2025',
    eventTitle: 'Olivia Graduates High School',
    imageUrl:
      'https://images.unsplash.com/photo-1616701318247-e87eb43e79e3?auto=format&fit=crop&w=1600&q=80',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1616701318247-e87eb43e79e3?auto=format&fit=crop&w=420&q=75',
    filename: 'demo-seed-graduation-highschool.jpg',
  },
  {
    eventKey: 'yellowstone-old-faithful-2019',
    eventTitle: 'Day 1: Old Faithful and Junior Ranger Badges',
    imageUrl:
      'https://images.unsplash.com/photo-1501641466388-c67e34ec767e?auto=format&fit=crop&w=1600&q=80',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1501641466388-c67e34ec767e?auto=format&fit=crop&w=420&q=75',
    filename: 'demo-seed-old-faithful.jpg',
  },
  {
    eventKey: 'yellowstone-grand-prismatic-2019',
    eventTitle: 'Day 2: Grand Prismatic Overlook Hike',
    imageUrl:
      'https://images.unsplash.com/photo-1607550295261-851fa60d8ed2?auto=format&fit=crop&w=1600&q=80',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1607550295261-851fa60d8ed2?auto=format&fit=crop&w=420&q=75',
    filename: 'demo-seed-old-faithful.jpg',
  },
  {
    eventKey: 'olivia-born-2009',
    eventTitle: 'Olivia Is Born',
    imageUrl:
      'https://images.unsplash.com/photo-1604917621956-10dfa7cce2e7?auto=format&fit=crop&w=1600&q=80',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1604917621956-10dfa7cce2e7?auto=format&fit=crop&w=420&q=75',
    filename: 'demo-seed-old-faithful.jpg',
  },
]

async function fetchBytes(url: string): Promise<Uint8Array> {
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error(`Failed to fetch demo media: ${url} (${response.status})`)
  }
  const arrayBuffer = await response.arrayBuffer()
  return new Uint8Array(arrayBuffer)
}

function toSizeMB(bytesLength: number): string {
  return (bytesLength / 1024 / 1024).toFixed(2)
}

export async function seedDemoMedia(db: DrizzleDb): Promise<void> {
  if (typeof window === 'undefined') return

  const indexedDbAdapter = new IndexedDBAdapter()

  for (const media of demoMediaSeeds) {
    const [eventRow] = await db
      .select({ id: eventsTable.id })
      .from(eventsTable)
      .where(eq(eventsTable.originalText, `demo:${media.eventKey}`))
      .limit(1)

    let eventId = eventRow?.id

    if (!eventId) {
      const [fallbackEventRow] = await db
        .select({ id: eventsTable.id })
        .from(eventsTable)
        .where(eq(eventsTable.title, media.eventTitle))
        .limit(1)
      eventId = fallbackEventRow?.id
    }

    if (!eventId) {
      continue
    }

    const existingDemoThumbnail = await db
      .select({ id: eventFilesTable.id, storageId: eventFilesTable.storageId })
      .from(eventFilesTable)
      .where(
        and(
          eq(eventFilesTable.eventId, eventId),
          eq(eventFilesTable.fileType, 'THUMBNAIL'),
          eq(eventFilesTable.filename, media.filename),
        ),
      )
    const existingDemoImage = await db
      .select({ id: eventFilesTable.id, storageId: eventFilesTable.storageId })
      .from(eventFilesTable)
      .where(
        and(
          eq(eventFilesTable.eventId, eventId),
          eq(eventFilesTable.fileType, 'IMAGE'),
          eq(eventFilesTable.filename, media.filename),
        ),
      )

    if (existingDemoThumbnail.length > 0 && existingDemoImage.length > 0) {
      const thumbnailStorageId = existingDemoThumbnail[0]?.storageId
      const imageStorageId = existingDemoImage[0]?.storageId
      const hasThumbnail = thumbnailStorageId ? await indexedDbAdapter.exists(thumbnailStorageId) : false
      const hasImage = imageStorageId ? await indexedDbAdapter.exists(imageStorageId) : false

      if (hasThumbnail && hasImage) {
        continue
      }
    }

    const staleRows = [...existingDemoThumbnail, ...existingDemoImage]
    for (const row of staleRows) {
      await db.delete(eventFilesTable).where(eq(eventFilesTable.id, row.id))
    }

    let thumbnailBytes: Uint8Array
    let imageBytes: Uint8Array
    try {
      [thumbnailBytes, imageBytes] = await Promise.all([
        fetchBytes(media.thumbnailUrl),
        fetchBytes(media.imageUrl),
      ])
    } catch (error) {
      console.warn(`Skipping demo media for "${media.eventTitle}" due to fetch failure:`, error)
      continue
    }

    const imageStorageId = `demo-media-image-${media.eventKey}`
    const thumbnailStorageId = `demo-media-thumb-${media.eventKey}`

    try {
      await indexedDbAdapter.store(
        imageBytes,
        {
          filename: media.filename,
          mimeType: 'image/jpeg',
          size: imageBytes.length,
          eventId,
          fileType: 'IMAGE',
        },
        imageStorageId,
      )

      await indexedDbAdapter.store(
        thumbnailBytes,
        {
          filename: `thumb-${media.filename}`,
          mimeType: 'image/jpeg',
          size: thumbnailBytes.length,
          eventId,
          fileType: 'THUMBNAIL',
        },
        thumbnailStorageId,
      )

      await db.insert(eventFilesTable).values([
        {
          eventId,
          storageId: thumbnailStorageId,
          fileType: 'THUMBNAIL',
          mimeType: 'image/jpeg',
          ext: 'jpg',
          fileSize: toSizeMB(thumbnailBytes.length),
          filename: media.filename,
        },
        {
          eventId,
          storageId: imageStorageId,
          fileType: 'IMAGE',
          mimeType: 'image/jpeg',
          ext: 'jpg',
          fileSize: toSizeMB(imageBytes.length),
          filename: media.filename,
        },
      ])
    } catch (error) {
      console.warn(`Skipping demo media for "${media.eventTitle}" due to storage failure:`, error)
      continue
    }
  }
}
